import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CrudService } from '../../../../core';
import { TipoArquivo } from '../tipo-arquivo';
import { TipoArquivoFilter } from '../filter';

@Injectable({
    providedIn: 'root'
})
export class TipoArquivoCrudHttpService {
    resource = 'tipos-arquivos';

    constructor(private crudService: CrudService) { }

    /** Procura um tipo de arquivo através do seu ID */
    find(id: number): Observable<TipoArquivo> {
        return this.crudService.find<TipoArquivo>(this.resource, id);
    }

    /** Carrega um tipo de arquivo através do seu ID */
    load(id: number): Observable<TipoArquivo> {
        return this.crudService.load<TipoArquivo>(this.resource, id);
    }

    /** Insere um novo tipo de arquivo */
    insert(entity: TipoArquivo): Observable<TipoArquivo> {
        return this.crudService.insert<TipoArquivo>(this.resource, entity);
    }

    /** Altera um tipo de arquivo existente */
    update(entity: TipoArquivo): Observable<TipoArquivo> {
        return this.crudService.update<TipoArquivo>(this.resource, entity);
    }

    /** Exclui um tipo de arquivo através do seu ID */
    delete(id: number): Observable<string> {
        return this.crudService.delete(this.resource, id);
    }
}
